<flx-modal
  [dismissible]="true"
  (dismiss)="closeModal()"
  class="flx-ds medium"
>
  <div
    class="flx-modal-title font-normal"
    flxModalHeaderTitle
  >
    Delete attribute <span class="font-semibold">{{ data.attribute?.name }}</span>
  </div>

  @let hasRelationsOrReferences = hasRelationsOrReferences$ | async;

  @if (hasRelationsOrReferences) {
    <div
      class="flx-modal-subtitle text-sm text-neutral-700"
      flxModalHeaderSubtitle
    >
      Your action will affect
      <span class="font-semibold">{{ data.entity?.name }}</span> entity definition. Check below the
      references and relationships where
      <span class="font-semibold">{{ data.attribute?.name }}</span> attribute is being used.
    </div>
  }

  @if (hasRelationsOrReferences) {
    <div class="flx-modal-body">
      @for (path of attributeReferences$ | async; track path) {
        <flx-attribute-references
          [isCollapsable]="$count > 1"
          [references]="path.references"
          [path]="path.path"
          [resourceType]="data.resourceType"
        />
      }
    </div>
  }

  <div class="flx-modal-footer">
    <div class="flx-modal-footer__right">
      <button
        (click)="closeModal()"
        class="flx-ds secondary"
        data-ts="confirmation-modal-cancel-button"
        flxButton
        type="button"
        variant="ghost"
      >
        Cancel
      </button>
      <button
        (click)="onConfirm()"
        class="flx-ds primary danger"
        data-testId="confirmation-modal-confirm-button"
        flxButton
        type="button"
      >
        Delete
      </button>
    </div>
  </div>
</flx-modal>
